import * as React from 'react';

import { IFlatInfoSchema } from '../../../types/results';
import { Text } from '../../Text';

export interface IFlatInfoProps {
  flatInfo: IFlatInfoSchema;
}

export function FlatInfo({ flatInfo }: IFlatInfoProps) {
  const { rentTypeText } = flatInfo;

  if (!rentTypeText) {
    return null;
  }

  return (
    <div>
      <Text textSize="small" color="gray">
        {rentTypeText}
      </Text>
    </div>
  );
}
